var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"author-page"},[_c('AuthorTopTab'),_c('div',{staticClass:"author-page-container"},[_c('router-view')],1),_c('AuthorBottomFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }